import React, { useState } from 'react';
import { Button } from '../ui/button';
import { Sparkles, Loader2, Check } from 'lucide-react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const SaveTemplateModal = ({ open, onClose, content, productType, categories }) => {
  const [name, setName] = useState(content?.title || '');
  const [category, setCategory] = useState(categories[0] || 'other');
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);

  if (!open) return null;

  const handleSave = async () => {
    if (!name.trim()) return;
    setSaving(true);
    try {
      await axios.post(`${API}/templates/save`, {
        name,
        category,
        product_type: productType,
        structure: content,
        description: content?.instructions || content?.caption || '',
        tags: [productType, category].filter(Boolean),
      });
      setSaved(true);
      setTimeout(() => { onClose(); setSaved(false); setName(''); }, 1500);
    } catch (err) {
      console.error('Save template failed:', err);
    }
    setSaving(false);
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/30 backdrop-blur-sm" onClick={onClose}>
      <div data-testid="save-template-modal" className="bg-white rounded-2xl shadow-xl border border-stone-100 p-6 w-full max-w-md mx-4" onClick={e => e.stopPropagation()}>
        {saved ? (
          <div className="text-center py-6">
            <div className="w-12 h-12 rounded-full bg-green-100 flex items-center justify-center mx-auto mb-3">
              <Check className="w-6 h-6 text-green-600" />
            </div>
            <h3 className="font-sans font-bold text-stone-800 text-lg">Template saved!</h3>
            <p className="text-sm font-sans text-stone-500 mt-1">Find it under Templates &gt; My templates</p>
          </div>
        ) : (
          <>
            <h3 className="font-sans font-bold text-stone-800 text-lg mb-4">Save as template</h3>
            <p className="text-sm font-sans text-stone-500 mb-5">Save this design as a reusable template you can remix anytime.</p>
            <div className="space-y-4">
              <div>
                <label className="text-xs font-sans font-medium text-stone-500 mb-1 block">Malnavn</label>
                <input
                  data-testid="template-name-input"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  placeholder="e.g. Min mal"
                  className="w-full text-sm font-sans text-stone-800 bg-stone-50 border border-stone-200 rounded-lg px-3 py-2.5 focus:border-primary focus:ring-1 focus:ring-primary/20 outline-none"
                />
              </div>
              <div>
                <label className="text-xs font-sans font-medium text-stone-500 mb-1.5 block">Kategori</label>
                <div className="flex flex-wrap gap-2">
                  {categories.map(cat => (
                    <button
                      key={cat}
                      data-testid={`template-category-${cat}`}
                      onClick={() => setCategory(cat)}
                      className={`px-3 py-1.5 rounded-full text-xs font-sans font-semibold border capitalize transition-all ${
                        category === cat ? 'border-primary bg-primary/5 text-primary' : 'border-stone-200 text-stone-500 hover:border-stone-300'
                      }`}
                    >
                      {cat}
                    </button>
                  ))}
                </div>
              </div>
            </div>
            <div className="flex items-center gap-3 mt-6">
              <Button
                data-testid="confirm-save-template"
                onClick={handleSave}
                disabled={saving || !name.trim()}
                className="flex-1 bg-primary text-primary-foreground hover:bg-primary/90 rounded-xl py-5 font-sans font-semibold"
              >
                {saving ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <Sparkles className="w-4 h-4 mr-2" />}
                Save template
              </Button>
              <Button variant="ghost" onClick={onClose} className="text-stone-500 font-sans">Cancel</Button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default SaveTemplateModal;
